import { render, staticRenderFns } from "./PatientDetailsTabs.vue?vue&type=template&id=624c5f78"
import script from "./PatientDetailsTabs.vue?vue&type=script&lang=js"
export * from "./PatientDetailsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports